// extracted by mini-css-extract-plugin
export var tag = "tag_link-module--tag--3xbh_";
export var activeTag = "tag_link-module--activeTag--G-9jN";